import React from 'react';

import Button, { ButtonGroup } from 'components/Button';
import Modal from 'components/Modal';
import { RemoveSubscriberFromLabel } from 'graphql/queries/label';
import useMutationWithAlert from 'hooks/graphql/useMutationWithAlert';
import { useAppDispatch } from 'hooks/redux';
import useBreakpoint from 'hooks/useBreakpoint';
import { showAlert } from 'redux/actions/ui';
import { useLabelSubscribersContext } from './LabelSubscribersContext';
import { TextEmphasis } from '@protonradio/proton-ui';

const ConfirmRemoveSubscriberModal = () => {
  const dispatch = useAppDispatch();
  const { confirmationModal, setConfirmationModal, label } = useLabelSubscribersContext();
  const close = () => setConfirmationModal(null);

  const [{ fetching: isSubmitting }, removeSubscriber] = useMutationWithAlert(
    RemoveSubscriberFromLabel
  );

  const isSmallScreen = useBreakpoint(
    useBreakpoint.BREAKPOINTS.SMALL,
    useBreakpoint.DIRECTIONS.DOWN
  );

  if (!confirmationModal || confirmationModal.type !== 'remove-subscriber') return null;
  const { artist } = confirmationModal;

  const handleRemoveSubscriber = async () => {
    const { hasErrors } = await removeSubscriber({
      labelId: label.id,
      artistId: artist!.id
    });
    if (!hasErrors) {
      dispatch(
        showAlert({
          component: 'LabelSubscriberAction',
          componentProps: { artist, label, action: 'removed' },
          timeout: 5000
        })
      );
    }

    close();
  };

  return (
    <Modal
      title="Remove Subscriber"
      subtitle={
        <span>
          Are you sure you want to remove <TextEmphasis>{artist!.name}</TextEmphasis> from
          your subscribers?
        </span>
      }
      onClose={close}
      frozen={isSubmitting}
    >
      <ButtonGroup justify={isSmallScreen ? 'center' : undefined} className="mt-3">
        <Button disabled={isSubmitting} color={Button.COLORS.NEUTRAL} onClick={close}>
          Cancel
        </Button>
        <Button
          disabled={isSubmitting}
          data-testid={TEST_IDS.REMOVE_SUBSCRIBER_CONFIRM}
          onClick={handleRemoveSubscriber}
        >
          Remove Subscriber
        </Button>
      </ButtonGroup>
    </Modal>
  );
};

const TEST_IDS = {
  CONFIRMATION_MODAL: 'confirm-remove-subscriber-modal',
  REMOVE_SUBSCRIBER_CONFIRM: 'remove-subscriber-confirm'
};

ConfirmRemoveSubscriberModal.TEST_IDS = TEST_IDS;

export default ConfirmRemoveSubscriberModal;
